// Story 11.2 / 11.4 — Helpers puros para las preferencias de paneles del
// editor. Aislado del Zustand store para tests sin deps.

export const DIAGRAM_MIN_PCT = 20;
export const DIAGRAM_MAX_PCT = 50;
export const DIAGRAM_DEFAULT_PCT = 30;

export function clampDiagramSize(pct: number): number {
  if (!Number.isFinite(pct)) return DIAGRAM_DEFAULT_PCT;
  return Math.min(Math.max(pct, DIAGRAM_MIN_PCT), DIAGRAM_MAX_PCT);
}

// Story 11.4 — panel de logs (vertical split). El log panel es altura, no
// ancho, así que el rango es chico (15..50% del alto del editor).
export const LOGS_MIN_PCT = 15;
export const LOGS_MAX_PCT = 50;
export const LOGS_DEFAULT_PCT = 25;

export function clampLogsPanelSize(pct: number): number {
  if (!Number.isFinite(pct)) return LOGS_DEFAULT_PCT;
  return Math.min(Math.max(pct, LOGS_MIN_PCT), LOGS_MAX_PCT);
}

// Story 11.4 — presets de layout que el menu `[…]` puede aplicar de un click.
export type LayoutPreset = 'split' | 'code-only' | 'code-diagram' | 'diagram-expanded';

export interface LayoutPresetState {
  diagramVisible: boolean;
  diagramSize: number;
  logsCollapsed: boolean;
  logsPanelSize: number;
}

/**
 * P-445 (review 11.4): el preset solo controla VISIBILIDAD; preservamos
 * los `*Size` que el user haya resizeado a mano. Antes el preset reseteaba
 * sizes a defaults y "Split" (que es el preset default) tiraba abajo
 * cualquier resize manual al re-aplicarlo. El caller pasa el state actual;
 * el preset modifica solo los flags.
 *
 * `diagram-expanded` sigue forzando `diagramSize = DIAGRAM_MAX_PCT` porque
 * la intención del preset es presentación (demos) — el user explícitamente
 * pidió "expanded".
 */
export function presetToLayout(
  preset: LayoutPreset,
  current: LayoutPresetState,
): LayoutPresetState {
  switch (preset) {
    case 'code-only':
      return { ...current, diagramVisible: false, logsCollapsed: true };
    case 'code-diagram':
      return { ...current, diagramVisible: true, logsCollapsed: true };
    case 'diagram-expanded':
      return {
        ...current,
        diagramVisible: true,
        // Diagram-expanded es presentación; sí seteamos `MAX_PCT` adrede.
        diagramSize: DIAGRAM_MAX_PCT,
        logsCollapsed: true,
      };
    default:
      // 'split' — todo visible, sizes intactos.
      return { ...current, diagramVisible: true, logsCollapsed: false };
  }
}
